import { ExternalLink as ExternalLinkIcon } from "lucide-react";

import classes from "./deployFirstIntegration.module.css";

export const DeployFirstIntegration = () => (
  <div className={classes.card}>
    <p className={`${classes.title} text-doto`}>Time to deploy your first integration</p>
    <div className={classes.videoWrapper}>
      <iframe
        className={classes.video}
        src="https://www.youtube-nocookie.com/embed/fS9QD76jYns"
        title="Ampersand demo video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
    <div className={classes.action}>
      <a
        className={classes.button}
        href="https://docs.ampersand.ai/starter-project"
        target="_blank"
        rel="noopener noreferrer"
      >
        See quickstart
        <ExternalLinkIcon size={14} aria-hidden="true" />
      </a>
    </div>
  </div>
);
